module.exports = __webpack_public_path__ + "static/media/gal3.90a864f5.jpeg";